var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOutlineFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28794 5.7487L11.2046 7.66536H19.6667V17.2487H4.33335V5.7487H9.28794ZM10.0834 3.83203H4.33335C3.27919 3.83203 2.42627 4.69453 2.42627 5.7487L2.41669 17.2487C2.41669 18.3029 3.27919 19.1654 4.33335 19.1654H19.6667C20.7209 19.1654 21.5834 18.3029 21.5834 17.2487V7.66536C21.5834 6.6112 20.7209 5.7487 19.6667 5.7487H12L10.0834 3.83203Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineFolder);
export default __webpack_public_path__ + "static/media/ic_outline-folder.cad5fea97ecf524659b4c99c8cde8a9e.svg";
export { ForwardRef as ReactComponent };